import { ObjectLocation } from './clip-art';
import { Dimension, Location, Rectangle } from './meme.types';

export abstract class Graphic {
    abstract getType();
    abstract move(location: Location);
    abstract resize(mouseLocation: Location);
    abstract moveToView(area: Dimension);
    abstract getElementRect(): Rectangle;
    abstract getBoundingRect(): Rectangle;
    abstract setBoundingRect(rect: Rectangle);
    abstract getLocation(): ObjectLocation;
}
